var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 10V7A5 5 0 007 7v3H5v8a2 2 0 002 2h10a2 2 0 002-2v-8h-2zm-4 7a1 1 0 01-2 0v-4a1 1 0 012 0v4zm2-7H9V7a2.935 2.935 0 013-3 2.935 2.935 0 013 3v3z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgYXJpYS1oaWRkZW49InRydWUiIGZvY3VzYWJsZT0iZmFsc2UiPgogIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE3LDEwVjdBNSw1LDAsMCwwLDcsN3YzSDV2OGEyLDIsMCwwLDAsMiwySDE3YTIsMiwwLDAsMCwyLTJWMTBIMTdabS00LDdhMSwxLDAsMCwxLTIsMFYxM2ExLDEsMCwwLDEsMiwwdjRabTItN0g5VjdhMi45MzUsMi45MzUsMCwwLDEsMy0zLDIuOTM1LDIuOTM1LDAsMCwxLDMsM3YzWiIvPgo8L3N2Zz4K";
export { SvgLock as ReactComponent };